/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import SubMenuTab from 'DesignSystem/SubMenuTab/index'
import Tysiav2DocumentHeart from 'DesignSystem/Svgs/Tysiav2DocumentHeart/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs/DocumentsTab/Content",
  isSelected,
  colorActive,
  isHovered
  
}) {
let tabTabValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'tab',
})
let constantData = 'documents'
let aggregateData = fromAggregate.equals(tabTabValueData, constantData)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSelected,
  colorActive,
  isHovered
  
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
let colorActiveOrdtColorsGreen700 = colorActive ?? dtColorsGreen700
let colorActiveOrdtColorsGreen7001 = colorActive ?? dtColorsGreen700
let colorActiveOrdtColorsGreen7002 = colorActive ?? dtColorsGreen700
let colorActiveOrdtColorsGreen7003 = colorActive ?? dtColorsGreen700
  return (<React.Fragment
>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 text="Documents"
 onClick={onClick}
 data="tab.tab"
 data="'documents'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
 marginTop={dtSpaceXs}
 size="normal"
 color={dtColorsNeutral900}
>
{childProps => (
<Tysiav2DocumentHeart
{...childProps}
  viewPath={`${viewPath}/Tysiav2DocumentHeart`}
 fill2={childProps.isSelected ? colorActiveOrdtColorsGreen7003 : childProps.isHovered ? colorActiveOrdtColorsGreen7002 : dtColorsNeutral400}
 height={12}
 width={12}
/>
)}
</SubMenuTab>
{children}
</React.Fragment>)
}